// extracted by mini-css-extract-plugin
export var compactFilters = "_dp-4";
export var detailImage = "_dp-1";
export var dropdownContainer = "_dp-2";
export var imageContainer = "_dp-0";
export var selectedCard = "_dp-3";